import { wsService } from "./wsService";
import axios from "axios";

const section = "asns";
const api_url = process.env.VUE_APP_API_URL;

const STATE_PENDIENTE= "PEN";
const STATE_PROCESO = 'PRC';
const STATE_RECIBIDO = 'REC';
const STATE_CERRADO = "CER";
const STATE_CANCELADO = "CAN";

const SUB_STATE_CON_DIFERENCIA = "DIF";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function updateObservaciones(param = {}) {
  return wsService.make_put_request(section + "/observaciones/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function list_status() {
  return wsService.make_get_request(section + "/list_status");
}

function list_sub_status() {
  return wsService.make_get_request(section + "/list_sub_status");
}

function get(param = { enable: true }) {
  return wsService.make_post_request(section + "/get", param);
}

function close(param = {}) {
  return wsService.make_post_request(section + "/close", param);
}

function cancel(param = {}) {
  return wsService.make_post_request(section + "/cancel", param);
}

function receiveItem(param = {}) {
  return wsService.make_post_request(section + "/receive", param);
}

function deleteDetailReceived(param = {}) {
  return wsService.make_post_request(section + "/delete_detail_received", param);
}

function getMotivos() {
  return wsService.make_post_request(section + "/list_motivos_rechazo");
}

function getSummary(param = {}) {
  return wsService.make_post_request(section + "/list_received_summary", param);
}

function validateDifferences(param = {}) {
  return wsService.make_post_request(section + "/validate-differences", param);
}

function get_historial(param = {}) {
  return wsService.make_post_request(section + "/get-historial", param);
}

function print_asn(asn_id, params = {}) {
  return wsService.make_post_request(
    section + "/print_asn/" + asn_id,
    params,
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    }
  );
}

function printLabel(param = {}, format = "pdf") {
  const token = localStorage.getItem("token");
  return axios.post(api_url + section + "/print-label/" + format, param, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/pdf",
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "Bearer " + token,
    },
  }).catch((error) => {
    console.error("Network Error:", error);
  });
} 

function printWitness(asn_id, params = {}) {
  const token = localStorage.getItem("token");
  return axios.post(api_url + section + "/print-witness/" + asn_id, params, {
    responseType: "arraybuffer",
    headers: {
      Accept: "application/pdf",
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "Bearer " + token,
    },
  }).catch((error) => {
    console.error("Network Error:", error);
  });
}

function getLpnsFromAsn(asn_id) {
  return wsService.make_post_request(section + "/get-lpns", { asn_id });
}

function getStatusName(estado) {
  switch (estado) {
    case STATE_PENDIENTE:
      return 'Pendiente de ingreso';
    case STATE_PROCESO:
      return 'En proceso';
    case STATE_RECIBIDO:
      return 'Recibido';
    case STATE_CERRADO:
      return 'Cerrado';
    case STATE_CANCELADO:
      return 'Cancelado';
    default:
      return 'Desconocido';
  }
}

//Solo se pueden editar las observaciones de un ASN que ya no esta pendiente de ingreso
function canEditObservaciones(status_id) {
  return [STATE_PROCESO, STATE_RECIBIDO, STATE_CERRADO].includes(status_id);
}

//Solo se puede cancelar un ASN que todavia esta pendiente de ingreso
function canCancelar(status) {
  return status === STATE_PENDIENTE;
}

function getSubStatusName(sub_status) {
  switch (sub_status) {
    case SUB_STATE_CON_DIFERENCIA:
      return 'Cerrado con diferencia';
    default:
      return 'Desconocido';
  }
}

function download_excel(errors_data = null) {
  if (errors_data !== null) {
    return wsService.make_post_request(section + "/get-excel-with-errors", {
      errors_data: errors_data,
    });
  } else {
    return wsService.make_get_request(section + "/get-sample-excel");
  }
}

function import_line_excel(param = {}) {
  return wsService.make_post_request(section + "/import-line", param);
}

export const asnService = {
  STATE_CERRADO,
  STATE_PENDIENTE,
  STATE_PROCESO,
  STATE_RECIBIDO,
  STATE_CANCELADO,
  SUB_STATE_CON_DIFERENCIA,

  section,
  filter,
  remove,
  create,
  update,
  updateObservaciones,
  canEditObservaciones,
  canCancelar,
  get,
  close,
  cancel,
  list_status,
  receiveItem,
  deleteDetailReceived,
  getMotivos,
  getSummary,
  validateDifferences,
  getStatusName,
  print_asn,
  printLabel,
  printWitness,
  getLpnsFromAsn,
  list_sub_status,
  get_historial,
  getSubStatusName,
  download_excel,
  import_line_excel
};
